"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const SkillTag_style_1 = require("./SkillTag.style");
const SkillTag = ({ label, closable, onClose }) => {
    const onPreventMouseDown = event => {
        event.preventDefault();
        event.stopPropagation();
    };
    return ((0, jsx_runtime_1.jsx)(SkillTag_style_1.CustomTag, { onMouseDown: onPreventMouseDown, closable: closable, onClose: onClose, children: label }));
};
exports.SkillTag = SkillTag;
